import React, {Component} from 'react';
import {Link} from 'react-router-dom';
import {Helmet} from "react-helmet";
import {Breadcrumb, Button, Card, Container, Image, Message, Table} from 'semantic-ui-react';


import CustomDivider from '../../components/extras/CustomDivider';
import GalleryStoreData from "../../data/GalleryStoreData";
import Loading from "../extras/Loading";
import MainToolbar from "../extras/MainToolbar";
import QuestionDialog from "../extras/QuestionDialog";
import update from "react-addons-update";
import connect from "react-redux/es/connect/connect";
import {showToast} from "../../actions/ToastAction";
import ImageUploadDialog from "../extras/ImageUploadDialog";
import CheckPermission from "../extras/CheckPermission";

class Gallery extends Component {
    constructor(){
        super();
        this.state = {
            data: {
                count: 0,
                next: "",
                previous: "",
                results: []
            },
            deleting: null,
            loading: true,
            loading_more: false,
            page: 1,
        }
    }
    async componentDidMount(){
       this.initialFetch(1);
    }

    async initialFetch(page) {
        const data = await GalleryStoreData.list(page);
        if (this.state.page === 1) {
            this.setState({data, loading: false, loading_more:false});
        }else{
            let oldData = this.state.data.results.slice();
            let newData = update(this.state, {
                data: {
                    results: {
                        $set: oldData.concat(data.results)
                    },
                    next: {
                        $set: data.next
                    }
                }
            });
            this.setState(newData);
        }
        this.setState({loading_more:false});
    }

    handleDelete = (id) =>{
        this.refs.question.open('Borrar esta fotografía', id);
    };

    openDialog = () => {
        this.refs.uploadDialog.handleOpen();
    };

    handleAddImage = (image) => {
        let data = { image };
        GalleryStoreData.add(data, res =>{
            if(res.save){
                let data = this.state.data;
                data.results.push(res.data);
                this.setState({data});
                this.props.showToast({message: 'Fotografía Agregada!', type: 'success'});
            }else{
                this.props.showToast({message: 'Tenemos un problema!', type: 'error'});
            }
            this.refs.uploadDialog.handleClose();
        });
    };

    deleteImage = (id) => {
        this.setState({deleting:id});
        GalleryStoreData.delete(id, (res) => {
            if (res.deleted) {
                let results = this.state.data.results.filter(image => {return image.id !== id});
                let data = update(this.state, {
                    data: {
                        results: {
                            $set: results
                        }
                    }
                });
                this.setState(data);
                this.props.showToast({message: 'Fotografía Borrada!', type: 'success'});
            } else {
                this.props.showToast({message: 'Tenemos un problema!', type: 'error'});
            }
            this.setState({deleting:null});
        });
    };

    callbackSearch = () =>{};

    loadMore = () => {
        let page = this.state.page + 1;
        this.setState({page, loading_more:true});
        this.initialFetch(page);
    };

    render() {
        return (
            <div>
                <Helmet>
                    <title>Mi Negocio | Galería Fotográfica - Bisttros</title>
                </Helmet>
                <Breadcrumb>
                    <Breadcrumb.Section as={Link} to='/settings'>Configuraciones</Breadcrumb.Section>
                    <Breadcrumb.Divider/>
                    <Breadcrumb.Section active>Galería Fotográfica</Breadcrumb.Section>
                </Breadcrumb>
                <CustomDivider/>
                <Container>
                    {
                        !this.state.loading ? <div>
                            <Table celled>
                                <Table.Header>
                                    <Table.Row>
                                        <Table.HeaderCell colSpan='2'>
                                            <MainToolbar title="Galería Fotográfica" name="Fotografía" ref="toolbar" icon="images outline" btnAdd={true}
                                                         callbackAdd={this.openDialog} />
                                        </Table.HeaderCell>
                                    </Table.Row>
                                </Table.Header>
                            </Table>
                                {this.state.data.results.length > 0 ? <div>
                                    <Card.Group itemsPerRow={4}>
                                {this.state.data.results.map(image =>{
                                    return(
                                        <Card raised key={image.id}>
                                            <Image src={`${image.image_url}?tr=w-400,ar-16-9`} height='120'/>
                                            <Card.Content extra>
                                                <Button
                                                    primary
                                                    fluid
                                                    content='Borrar'
                                                    icon='trash'
                                                    labelPosition='left'
                                                    loading={image.id === this.state.deleting}
                                                    onClick={() => this.handleDelete(image.id)}
                                                />
                                            </Card.Content>
                                        </Card>
                                    )
                                })}
                                    </Card.Group>
                                    {this.state.data.next ? <p>
                                        <br/>
                                        <Button fluid onClick={() => this.loadMore()} disabled={this.state.loading_more} loading={this.state.loading_more}>Cargar Más</Button>
                                    </p>:null}
                                </div>:<div style={{width:'100%'}}><br/><Message icon='bell' header='No hay información registrada'/></div>}
                        </div>:<Loading/>
                    }
                </Container>
                <QuestionDialog ref='question' callbackConfirm={this.deleteImage}/>
                <ImageUploadDialog ref="uploadDialog" title="Fotografía"
                                   callbackLoadImage={this.handleAddImage}/>
                <CheckPermission access='settings_gallery'/>
            </div>
        );
    }
}

function mapDispatchToProps(dispatch){
    return {
        showToast(toast){
            dispatch(showToast(toast))
        },
    }
}

export default connect(
    null,
    mapDispatchToProps
)(Gallery)


// WEBPACK FOOTER //
// ./src/components/settings/Gallery.js